import { supabase } from '@/integrations/supabase/client';

/**
 * Emit an engagement event to the server.
 * Fire-and-forget — never throws, never blocks the UI.
 */
export async function emitEngagementEvent(
  eventType: string,
  metadata?: Record<string, unknown>
): Promise<void> {
  try {
    await supabase.functions.invoke('process-engagement-event', {
      body: { eventType, metadata },
    });
  } catch {
    // Fire-and-forget — engagement tracking failure shouldn't block the UI
  }
}
